var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconTextAnnotation = function SvgMiconTextAnnotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M2 7v2h7v16h2V9h7V7zM30 11.076l-.744-1.857L26 10.522V7h-2v3.523L20.744 9.22 20 11.077l3.417 1.367L20.9 15.8l1.6 1.2 2.5-3.333L27.5 17l1.6-1.2-2.517-3.357z"
  })));
};
export default SvgMiconTextAnnotation;